module.exports = __webpack_public_path__ + "static/img/6.1aca8596.jpg";